import HeaderLogo from '@/assets/logo_twm.png'
import { COLOR, DATE_FORMAT_CN } from '@/libs/core/constants'
import { getImageSize, pixelToDxa } from '@/libs/utils/docxUtils'
import { AlignmentType, ImageRun, Paragraph, TextRun } from 'docx'
import moment from 'moment'

const CoverPage = async ({ reportData }) => {
  const { reportDate, firstPartyFullName } = reportData || {}

  const { width, height } = await getImageSize({ image: HeaderLogo, width: 502 })
  const imgData = await fetch(HeaderLogo)

  return [
    new Paragraph({
      alignment: AlignmentType.CENTER,
      spacing: { before: pixelToDxa(100), after: pixelToDxa(200) },
      children: [
        new ImageRun({
          data: await imgData.blob(),
          transformation: {
            width,
            height,
          },
        }),
      ],
    }),
    new Paragraph({
      style: 'coverTitle',
      alignment: AlignmentType.CENTER,
      spacing: { line: pixelToDxa(30) },
      children: [
        new TextRun({ text: '資安教育訓練服務' }),
        new TextRun({ text: '結果及分析報告書', break: 1 }),
      ],
      border: { bottom: { color: '#000000', space: 10, style: 'single', size: 1 } },
    }),
    new Paragraph({
      style: 'coverTitle',
      alignment: AlignmentType.CENTER,
      spacing: { before: pixelToDxa(50), after: pixelToDxa(50) },
      children: [new TextRun({ text: firstPartyFullName, color: COLOR.primary })],
    }),
    new Paragraph({
      style: 'coverSubtitle',
      alignment: AlignmentType.CENTER,
      children: [
        new TextRun({ text: moment(reportDate).format(DATE_FORMAT_CN), color: COLOR.primary }),
      ],
    }),
  ]
}

export default CoverPage
